import styles from './gap.module.css';

import type {
  SpacingSize,
  SpacingSizeResponsive,
  SpacingValue,
} from '../../styles/spacing';

export interface GridGapProps {
  /* Set the gap between grid rows and columns. */
  gap?: SpacingValue | SpacingSize | SpacingSizeResponsive;
  /** Set the gap between grid columns. */
  columnGap?: SpacingValue | SpacingSize | SpacingSizeResponsive;
  /** Set the gap between grid rows. */
  rowGap?: SpacingValue | SpacingSize | SpacingSizeResponsive;
}

/** Return the CSS classes to render the gap. */
export function getGapStyles(props: GridGapProps): string[] {
  let { columnGap: colValue, rowGap: rowValue } = props;

  if (props.gap) {
    colValue = props.gap;
    rowValue = props.gap;
  }

  const gapStyles: string[] = [styles['gap']];

  if (colValue) {
    let colGap: SpacingSizeResponsive | undefined;
    gapStyles.push(styles['col-gap']);
    if (typeof colValue === 'string' || typeof colValue === 'number') {
      colGap = { xs: colValue };
    } else {
      colGap = colValue;
    }
    if (colGap?.xs) {
      gapStyles.push(styles[`xs-col-${colGap.xs}`]);
    }
    if (colGap?.sm) {
      gapStyles.push(styles[`sm-col-${colGap.sm}`]);
    }
    if (colGap?.md) {
      gapStyles.push(styles[`md-col-${colGap.md}`]);
    }
    if (colGap?.lg) {
      gapStyles.push(styles[`lg-col-${colGap.lg}`]);
    }
    if (colGap?.xl) {
      gapStyles.push(styles[`xl-col-${colGap.xl}`]);
    }
  }

  if (rowValue) {
    let rowGap: SpacingSizeResponsive | undefined;
    gapStyles.push(styles['row-gap']);
    if (typeof rowValue === 'string' || typeof rowValue === 'number') {
      rowGap = { xs: rowValue };
    } else {
      rowGap = rowValue;
    }
    if (rowGap?.xs) {
      gapStyles.push(styles[`xs-row-${rowGap.xs}`]);
    }
    if (rowGap?.sm) {
      gapStyles.push(styles[`sm-row-${rowGap.sm}`]);
    }
    if (rowGap?.md) {
      gapStyles.push(styles[`md-row-${rowGap.md}`]);
    }
    if (rowGap?.lg) {
      gapStyles.push(styles[`lg-row-${rowGap.lg}`]);
    }
    if (rowGap?.xl) {
      gapStyles.push(styles[`xl-row-${rowGap.xl}`]);
    }
  }
  return gapStyles;
}
